/* Learning Center — multi-blog resource library.
   · Content type  = blog category (single-select).
   · Safety features = article tags (multi-select, OR).
   · In-page live search (debounced, no navigation).
   · URL param: /pages/learning-center?category=case-studies auto-applies that
     Content type filter on load; filter changes are reflected back into the URL
     (history.replaceState) so any filtered view is shareable/bookmarkable.
   Filtering + search + pagination run in-page.
   Category auto-sync with Shopify admin:
     - DELETED blogs disappear automatically server-side (blogs[handle] is blank).
     - NEW blogs are discovered client-side: parse /sitemap_blogs_1.xml for depth-1
       /blogs/<handle> URLs, fetch each new blog's JSON feed (?view=lc-feed), then
       inject its Content type category, its article cards and any new Safety
       feature tags — no need to edit the section setting.
   Pure helpers (matches / pageCount / pageWindow / parseSitemapHandles) are
   exported for Node unit tests; init() only auto-runs in a browser. */
(function (root, factory) {
  var LC = factory();
  if (typeof module !== 'undefined' && module.exports) { module.exports = LC; }
  if (root) { root.LC = LC; }
  if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') { LC.init(); }
    else { document.addEventListener('DOMContentLoaded', LC.init); }
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ---------- pure helpers (no DOM, unit-testable) ---------- */
  function activeFeatures(features) {
    var out = [];
    for (var k in features) { if (features[k]) out.push(k); }
    return out;
  }
  /* cardData: { blog: 'education', tags: 'cut-resistant impact', search: 'title education cut-resistant' } */
  function matches(cardData, state) {
    if (state.blog && cardData.blog !== state.blog) return false;
    if (state.query && (cardData.search || '').indexOf(state.query) === -1) return false;
    var feats = activeFeatures(state.features);
    if (!feats.length) return true;
    var tags = (cardData.tags || '').split(/\s+/).filter(Boolean);
    for (var i = 0; i < feats.length; i++) {
      if (tags.indexOf(feats[i]) !== -1) return true; // OR across selected tags
    }
    return false;
  }
  function pageCount(total, perPage) {
    if (perPage < 1) perPage = 1;
    return Math.max(1, Math.ceil(total / perPage));
  }
  function pageWindow(total, page, perPage) {
    var pages = pageCount(total, perPage);
    if (page > pages) page = pages;
    if (page < 1) page = 1;
    var start = (page - 1) * perPage;
    var end = Math.min(start + perPage, total);
    return { page: page, pages: pages, start: start, end: end };
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Parse a Shopify sitemap_blogs XML and return unique depth-1 blog handles
     ("/blogs/<handle>" only — article URLs like "/blogs/<handle>/<slug>" are excluded). */
  function parseSitemapHandles(xmlText) {
    var out = [];
    if (!xmlText) return out;
    var re = /<loc>\s*[^<]*\/blogs\/([A-Za-z0-9_-]+)\s*\/?\s*<\/loc>/g;
    var m;
    while ((m = re.exec(xmlText)) !== null) {
      var h = m[1].toLowerCase();
      if (out.indexOf(h) === -1) out.push(h);
    }
    return out;
  }
  /* Return a NEW array of the given elements sorted by their data-published
     unix timestamp. dir 'asc' = oldest first (chronological), 'desc' = newest first. */
  function sortByPublished(arr, dir) {
    var a = Array.prototype.slice.call(arr);
    a.sort(function (x, y) {
      var dx = parseInt(x.getAttribute('data-published'), 10) || 0;
      var dy = parseInt(y.getAttribute('data-published'), 10) || 0;
      return dir === 'desc' ? dy - dx : dx - dy;
    });
    return a;
  }
  /* Minimal query-string reader (no URLSearchParams dependency, Node-testable).
     getQueryParam('?a=1&category=case-studies', 'category') -> 'case-studies' */
  function getQueryParam(search, key) {
    if (!search) return null;
    var q = search.charAt(0) === '?' ? search.slice(1) : search;
    var pairs = q.split('&');
    for (var i = 0; i < pairs.length; i++) {
      if (!pairs[i]) continue;
      var idx = pairs[i].indexOf('=');
      var k = idx === -1 ? pairs[i] : pairs[i].slice(0, idx);
      var v = idx === -1 ? '' : pairs[i].slice(idx + 1);
      if (decodeURIComponent(k) === key) return decodeURIComponent(v.replace(/\+/g, ' '));
    }
    return null;
  }

  /* ---------- browser wiring ---------- */
  function init() {
    // Mobile off-canvas drawer
    var toggle = document.getElementById('lcFilterToggle');
    var sidebar = document.getElementById('lcSidebar');
    if (toggle && sidebar) {
      var close = function () { sidebar.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); };
      toggle.addEventListener('click', function () {
        var open = sidebar.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (sidebar.classList.contains('is-open') && !sidebar.contains(e.target) && !toggle.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    var grid = document.getElementById('lcGrid');
    if (!grid) return;
    var perPage = parseInt(grid.getAttribute('data-perpage'), 10) || 6;
    var cards = [];
    function refreshCards() { cards = Array.prototype.slice.call(grid.querySelectorAll('.lc__card')); }
    refreshCards();
    if (!cards.length) return;
    function getFacets() { return Array.prototype.slice.call(document.querySelectorAll('.lc__facet-link')); }
    var activeEl = document.getElementById('lcActive');
    var countEl = document.getElementById('lcCount');
    var emptyEl = document.getElementById('lcEmpty');
    var pagEl = document.getElementById('lcPagination');
    var allBtn = document.querySelector('[data-filter="all"]');
    var typeList = document.getElementById('lcTypeList');
    var featureList = document.getElementById('lcFeatureList');
    var featureFacet = document.getElementById('lcFeatureFacet');
    var searchForm = document.getElementById('lcSearch');
    var searchInput = document.getElementById('lcSearchInput');
    var searchTimer = null;

    var state = { blog: null, blogLabel: null, features: {}, query: '' };
    var page = 1;

    function cardData(c) {
      return {
        blog: c.getAttribute('data-blog') || '',
        tags: c.getAttribute('data-tags') || '',
        search: c.getAttribute('data-search') || ''
      };
    }

    function renderChips() {
      if (!activeEl) return;
      var parts = [];
      if (state.blog) {
        parts.push('<a href="#" class="lc__chip" data-remove="blog" data-value="' + state.blog + '">' + escapeHtml(state.blogLabel || state.blog) + ' &times;</a>');
      }
      activeFeatures(state.features).forEach(function (f) {
        parts.push('<a href="#" class="lc__chip" data-remove="feature" data-value="' + f + '">' + escapeHtml(state.features[f]) + ' &times;</a>');
      });
      if (parts.length) { activeEl.hidden = false; activeEl.innerHTML = parts.join(''); }
      else { activeEl.hidden = true; activeEl.innerHTML = ''; }
    }

    function renderPagination(total) {
      if (!pagEl) return;
      var w = pageWindow(total, page, perPage); page = w.page;
      if (w.pages <= 1) { pagEl.innerHTML = ''; return; }
      var h = '<a href="#" class="lc__page' + (page === 1 ? ' is-disabled' : '') + '" data-page="' + (page - 1) + '">&larr; Prev</a>';
      for (var p = 1; p <= w.pages; p++) {
        h += '<a href="#" class="lc__page' + (p === page ? ' is-current' : '') + '" data-page="' + p + '">' + p + '</a>';
      }
      h += '<a href="#" class="lc__page' + (page === w.pages ? ' is-disabled' : '') + '" data-page="' + (page + 1) + '">Next &rarr;</a>';
      pagEl.innerHTML = h;
    }

    /* Reflect the active blog filter into the URL (?category=<handle>) so a
       filtered view is shareable/bookmarkable, and typing the param + Enter
       lands on the filtered page. No reload; history state only. */
    function syncUrl() {
      if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return;
      var url = window.location.pathname + (state.blog ? '?category=' + encodeURIComponent(state.blog) : '');
      window.history.replaceState(null, '', url);
    }

    function apply() {
      var vis = cards.filter(function (c) { return matches(cardData(c), state); });
      var w = pageWindow(vis.length, page, perPage); page = w.page;
      cards.forEach(function (c) { c.style.display = 'none'; });
      vis.slice(w.start, w.end).forEach(function (c) { c.style.display = ''; });
      if (countEl) countEl.textContent = vis.length;
      if (emptyEl) emptyEl.hidden = !(vis.length === 0);
      renderPagination(vis.length);
      renderChips();
      if (allBtn) allBtn.classList.toggle('is-active', !state.blog && !state.query && activeFeatures(state.features).length === 0);
      syncUrl();
    }

    /* Programmatically select a Content type category (used for ?category= param). */
    function selectBlog(handle) {
      var link = null;
      getFacets().forEach(function (x) {
        if (x.getAttribute('data-filter') === 'blog' && x.getAttribute('data-value') === handle) link = x;
      });
      if (!link) return false;
      state.blog = handle;
      state.blogLabel = (link.textContent || '').trim();
      clearGroup('blog');
      link.classList.add('is-active');
      page = 1;
      apply();
      return true;
    }

    function applyQuery(q) {
      state.query = (q || '').trim().toLowerCase();
      page = 1;
      apply();
    }

    function clearGroup(filter) {
      getFacets().forEach(function (x) { if (x.getAttribute('data-filter') === filter) x.classList.remove('is-active'); });
    }

    function bindFacet(f) {
      f.addEventListener('click', function (e) {
        e.preventDefault();
        var filter = f.getAttribute('data-filter');
        var val = f.getAttribute('data-value');
        var label = (f.textContent || '').trim();
        if (filter === 'all') {
          state.blog = null; state.blogLabel = null; state.features = {}; state.query = ''; page = 1;
          if (searchInput) searchInput.value = '';
          getFacets().forEach(function (x) { x.classList.remove('is-active'); });
          f.classList.add('is-active');
          apply();
          return;
        }
        if (filter === 'blog') {
          if (state.blog === val) { state.blog = null; state.blogLabel = null; f.classList.remove('is-active'); }
          else { state.blog = val; state.blogLabel = label; clearGroup('blog'); f.classList.add('is-active'); }
        } else if (filter === 'feature') {
          if (state.features[val]) { delete state.features[val]; f.classList.remove('is-active'); }
          else { state.features[val] = label; f.classList.add('is-active'); }
        }
        page = 1;
        apply();
      });
    }
    getFacets().forEach(bindFacet);

    // In-page live search (HexArmor-style): typing filters the grid instantly,
    // without navigating to /search. Debounced; Enter/button submits also filter.
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () { applyQuery(searchInput.value); }, 250);
      });
      // native clear (x) button on type="search" fires 'search' in some browsers
      searchInput.addEventListener('search', function () { applyQuery(searchInput.value); });
    }
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(searchTimer);
        applyQuery(searchInput ? searchInput.value : '');
      });
    }

    if (pagEl) {
      pagEl.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('.lc__page') : null;
        if (!a) return;
        e.preventDefault();
        if (a.classList.contains('is-disabled')) return;
        var p = parseInt(a.getAttribute('data-page'), 10);
        if (!isNaN(p)) {
          page = p;
          apply();
          if (grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    if (activeEl) {
      activeEl.addEventListener('click', function (e) {
        var chip = e.target && e.target.closest ? e.target.closest('.lc__chip') : null;
        if (!chip) return;
        e.preventDefault();
        var kind = chip.getAttribute('data-remove');
        var val = chip.getAttribute('data-value');
        if (kind === 'blog') { state.blog = null; state.blogLabel = null; clearGroup('blog'); }
        else if (kind === 'feature') {
          delete state.features[val];
          getFacets().forEach(function (x) {
            if (x.getAttribute('data-filter') === 'feature' && x.getAttribute('data-value') === val) x.classList.remove('is-active');
          });
        }
        page = 1;
        apply();
      });
    }

    /* Initial render, then apply ?category=<handle> from the URL (typed in the
       address bar + Enter). If the blog isn't rendered server-side yet, keep it
       pending — auto-discovery will apply it once its feed loads. */
    var initialCategory = (getQueryParam(window.location.search, 'category') || '').toLowerCase();
    var pendingCategory = null;
    apply();
    if (initialCategory && !selectBlog(initialCategory)) {
      pendingCategory = initialCategory;
    }

    /* ---------- auto-discover blogs added in Shopify admin ----------
       Reads the (always up-to-date) blogs sitemap; any blog handle not already
       rendered server-side gets its JSON feed (?view=lc-feed) fetched and its
       category / cards / tags injected, then the view re-applies. */
    function ensureBlogFacet(handle, title) {
      if (!typeList) return;
      if (typeList.querySelector('[data-filter="blog"][data-value="' + handle + '"]')) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'lc__facet-link';
      a.setAttribute('data-filter', 'blog');
      a.setAttribute('data-value', handle);
      a.textContent = title;
      li.appendChild(a);
      typeList.appendChild(li);
      bindFacet(a);
    }

    function ensureFeatureFacet(rawTag, handle) {
      if (!featureList || !handle) return;
      if (featureList.querySelector('[data-filter="feature"][data-value="' + handle + '"]')) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'lc__facet-link';
      a.setAttribute('data-filter', 'feature');
      a.setAttribute('data-value', handle);
      a.textContent = rawTag;
      li.appendChild(a);
      featureList.appendChild(li);
      bindFacet(a);
      if (featureFacet) featureFacet.hidden = false;
    }

    function buildCard(blogHandle, blogTitle, a) {
      var art = document.createElement('article');
      art.className = 'lc__card';
      art.setAttribute('data-blog', blogHandle);
      art.setAttribute('data-tags', (a.tagHandles || []).join(' '));
      var search = a.search || (((a.title || '') + ' ' + (blogTitle || '') + ' ' + (a.tagHandles || []).join(' ')).toLowerCase());
      art.setAttribute('data-search', search);
      art.setAttribute('data-published', String(a.published || 0));
      var img = a.image ? '<img src="' + a.image + '" alt="" loading="lazy" />' : '';
      art.innerHTML =
        '<a href="' + a.url + '" class="lc__card-link">' +
          '<div class="lc__card-media">' + img + '</div>' +
          '<span class="lc__card-type"></span>' +
          '<h3 class="lc__card-title"></h3>' +
        '</a>';
      art.querySelector('.lc__card-type').textContent = blogTitle || blogHandle;
      art.querySelector('.lc__card-title').textContent = a.title || '';
      return art;
    }

    /* Re-order all cards in the grid by published date (direction from data-sort),
       so auto-injected articles land in their correct chronological position. */
    function resortDom() {
      var dir = grid.getAttribute('data-sort') || 'asc';
      sortByPublished(cards, dir).forEach(function (c) { grid.appendChild(c); });
      refreshCards();
    }

    function loadBlog(handle) {
      return fetch('/blogs/' + encodeURIComponent(handle) + '?view=lc-feed', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.handle) return;
          ensureBlogFacet(data.handle, data.title || data.handle);
          (data.articles || []).forEach(function (a) {
            grid.appendChild(buildCard(data.handle, data.title, a));
            (a.tags || []).forEach(function (t, i) {
              ensureFeatureFacet(t, (a.tagHandles || [])[i] || '');
            });
          });
          refreshCards();
          resortDom();
          apply();
          // If the URL asked for this blog (?category=...) before it was discovered, apply now.
          if (pendingCategory === data.handle) {
            selectBlog(pendingCategory);
            pendingCategory = null;
          }
        })
        .catch(function () { /* feed missing/unreachable -> skip silently */ });
    }

    function discoverBlogs() {
      if (typeof fetch !== 'function') return;
      fetch('/sitemap_blogs_1.xml', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) {
          if (!txt) return;
          var existing = (grid.getAttribute('data-handles') || '').split(/\s+/).filter(Boolean);
          var fresh = parseSitemapHandles(txt).filter(function (h) { return existing.indexOf(h) === -1; });
          return fresh.reduce(function (p, h) {
            return p.then(function () { return loadBlog(h); });
          }, Promise.resolve());
        })
        .catch(function () { /* discovery is an enhancement; base render already works */ });
    }
    discoverBlogs();
  }

  return {
    activeFeatures: activeFeatures,
    matches: matches,
    pageCount: pageCount,
    pageWindow: pageWindow,
    parseSitemapHandles: parseSitemapHandles,
    sortByPublished: sortByPublished,
    getQueryParam: getQueryParam,
    init: init
  };
});
